/* global axios */
import ApiClient from './ApiClient';

class UsageEventsAPI extends ApiClient {
  constructor() {
    super('usage_events');
  }

  record(accountId, menuItem) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/${this.resource}`,
      { menu_item: menuItem }
    );
  }
}

export default new UsageEventsAPI();
